import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, MessageSquare } from "lucide-react";
import { Logo } from "@/components/ui/Logo";
import { ScrollReveal } from "@/components/landing/ScrollReveal";
import { ThemeToggle } from "@/components/theme-toggle";

export default function Contact() {
  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border/40">
        <div className="container mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/">
            <Logo size="md" />
          </Link>
          <div className="flex items-center gap-3">
            <ThemeToggle className="h-8 w-8 shrink-0" />
            <Button variant="ghost" asChild>
              <Link to="/auth">Login</Link>
            </Button>
            <Button asChild>
              <Link to="/">Back to Home</Link>
            </Button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <section className="pt-32 pb-20 px-4">
        <div className="container mx-auto max-w-3xl">
          <ScrollReveal>
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8 transition-colors">
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>

            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight mb-6">
              Contact
            </h1>
            <p className="text-xl text-muted-foreground mb-12">
              Questions about Base, Pro, onboarding, or integrations? Get in touch and we'll reply within 24 hours.
            </p>

            <div className="space-y-6">
              <div className="p-6 rounded-[var(--radius-card)] border bg-card">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary flex-shrink-0">
                    <Mail className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Email Us</h3>
                    <p className="text-muted-foreground mb-4">
                      Send us an email and we'll get back to you within 24 hours.
                    </p>
                    <Button asChild>
                      <a href="mailto:info@decisionsalesos.com">
                        info@decisionsalesos.com
                      </a>
                    </Button>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-[var(--radius-card)] border bg-card">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary flex-shrink-0">
                    <MessageSquare className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-2">What we can help with</h3>
                    <p className="text-muted-foreground mb-4">
                      We can help you with:
                    </p>
                    <ul className="space-y-2 text-muted-foreground mb-4">
                      <li className="flex items-start gap-2">
                        <span className="text-primary mt-1">•</span>
                        <span>Choosing the right plan for your team</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-primary mt-1">•</span>
                        <span>Meta Lead Ads onboarding</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-primary mt-1">•</span>
                        <span>Workspace setup and user permissions</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-primary mt-1">•</span>
                        <span>Billing, checkout, and account questions</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 p-6 rounded-[var(--radius-card)] bg-secondary/30 border border-border/50">
              <p className="text-sm text-muted-foreground text-center">
                Already have an account?{" "}
                <Link to="/auth" className="text-primary hover:underline">
                  Sign in here
                </Link>
              </p>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}

